import styled from 'styled-components';
import { Description } from '../../index.view';

const SplitBillField = styled(Description)`
  font-size: 12px;
`;

const SplitBillContainer = styled.div`
  display: flex;
  justify-content: space-between;
  line-height: 0;
  margin-top: -10px;
`;

export { SplitBillField, SplitBillContainer };
